export default __webpack_public_path__ + "static/media/monarch-logo.20a1ab22.png";